import ServiceExec from '@/common/utils/ServiceExec';
import { asFormData } from '@/common/utils/Util';

const uploadImage = (file) => {
  const fileParameter = { file: file };
  const formData = asFormData(fileParameter);
  return ServiceExec.post('/common/upload', formData);
};

export { uploadImage };
